import { render, staticRenderFns } from "./ResourceCarousel.vue?vue&type=template&id=47094cbd&scoped=true&"
import script from "./ResourceCarousel.vue?vue&type=script&lang=ts&"
export * from "./ResourceCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceCarousel.vue?vue&type=style&index=0&id=47094cbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47094cbd",
  null
  
)

/* custom blocks */
import block0 from "./ResourceCarousel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCarousel,VCarouselItem,VCol,VDialog,VIcon,VRow})
